import { splitSecrets } from "@ext/agent/components/utils/secret/secretChatHighlight";
import { useAgentSecretNames } from "@ext/agent/components/utils/secret/useAgentSecretNames";
import Renderer from "@ext/markdown/core/render/components/Renderer";
import { CopyableInlineCode } from "@ext/markdown/elements/code/render/component/Code";

export const AgentChatInlineCode = ({ children }: { children: string }) => {
	const knownSecretNames = useAgentSecretNames();
	const parts = splitSecrets(children, knownSecretNames ?? []);

	return <CopyableInlineCode text={children}>{parts ? Renderer(parts) : children}</CopyableInlineCode>;
};
